import { request } from '@umijs/max';

export async function queryPortalsService() {
  return request(`/portals`).then((res) => {
    if (res?.length) {
      return res.map((item: any) => ({
        ...item,
        label: item.portalName,
        value: item.portalName,
      }));
    }
    return [];
  });
}

export async function queryMenusService() {
  return request(`/menus`).then((res) => {
    if (res?.length) {
      return res.map((item: any) => ({
        ...item,
        label: item.privName,
        value: item.privName,
      }));
    }
    return [];
  });
}

export async function deletePortalService(portalId: number) {
  return request(`/portals/${portalId}`, {
    method: 'DELETE',
  });
}

export async function editPortalService(data: any) {
  return request(`/portals`, {
    method: 'PUT',
    data,
  });
}

export async function addPortalService(data: any) {
  return request(`/portals`, {
    method: 'POST',
    data,
  });
}

export async function queryDirmenusService(portalId: number) {
  return request(`/portals/${portalId}/dirmenus`);
}

export async function queryDirsService(partyId: number) {
  return request(`/dirs/${partyId}/dirmenus`);
}

export async function addDirMenuToPortalService(portalId: number, data: any) {
  return request(`/bcare/portals/${portalId}/dirmenus`, {
    method: 'POST',
    data,
  });
}

export async function changeSeqService(portalId: number, data: any) {
  return request(`/portals/${portalId}/dirmenus/seq`, {
    method: 'PUT',
    data,
  });
}

export async function delDirMenuService(
  portalId: number,
  partyId: number,
  seq: number,
) {
  return request(`/bcare/portals/${portalId}/dirmenus/${partyId}/${seq}`, {
    method: 'DELETE',
  });
}
